module.exports = __webpack_public_path__ + "img/FLK.4b73d1ef.svg";